import styled from 'styled-components'
import { maxXs } from '../../styles/breakPoints'

export const Container = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  flex-direction: column;
  top: 0px;
  left: 0px;
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 0 0 auto;
  align-items: center;

  margin-bottom: 120px;

  .headline-section {
    @media (${maxXs}) {
      padding-left: 20px;
      padding-right: 20px;
    }

    margin-top: 120px;
    display: flex;
    justify-content: center;

    div {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    h1 {
      width: 622px;
      text-align: center;

      @media (${maxXs}) {
        width: 334px;
      }
    }

    span {
      width: 494px;
      margin-top: 20px;
      margin-bottom: 20px;
      text-align: center;

      @media (${maxXs}) {
        margin-top: 10px;
        width: 304px;
      }
    }

    @media (${maxXs}) {
      margin-top: 60px;

      flex-direction: column;
      justify-content: center;
      align-items: center;

      margin-right: 0px;
    }
  }

  .section {
    margin-top: 120px;

    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
    width: 940px;

    @media (${maxXs}) {
      width: 100%;
      margin-top: 60px;
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-direction: column;
    }
    img {
      width: 460px;
      height: 460px;
      object-fit: cover;

      @media (${maxXs}) {
        width: 332px;
        height: 332px;
      }
    }
  }

  .section-left {
    div {
      @media (${maxXs}) {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }
    }
    .left {
      display: flex;
      flex-direction: column;
      justify-content: center;

      width: 402px;
      @media (${maxXs}) {
        width: 332px;
      }

      span {
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
  }

  .section-right {
    div {
      @media (${maxXs}) {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      justify-content: center;

      width: 367px;
      @media (${maxXs}) {
        width: 332px;
      }

      span {
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
  }

  .mobile-hidden {
    @media (${maxXs}) {
      display: none !important;
    }
  }
`
